export type ActivateTalkdownOptionId =
  | 'english-trespassing'
  | 'french-trespassing'
  | 'english-loitering'
  | 'french-loitering'
  | 'siren';

export interface ActivateTalkdownOption {
  readonly id: ActivateTalkdownOptionId;
  /** One or two centered label lines shown above the Activate button. */
  readonly labelLines: readonly string[];
}

export const ACTIVATE_TALKDOWN_OPTIONS: readonly ActivateTalkdownOption[] = [
  {
    id: 'english-trespassing',
    labelLines: ['English', 'Trespassing'],
  },
  {
    id: 'french-trespassing',
    labelLines: ['French', 'Trespassing'],
  },
  {
    id: 'english-loitering',
    labelLines: ['English', 'Loitering'],
  },
  {
    id: 'french-loitering',
    labelLines: ['French', 'Loitering'],
  },
  {
    id: 'siren',
    labelLines: ['Siren'],
  },
] as const;

export interface ActivateTalkdownConfirm {
  readonly optionId: ActivateTalkdownOptionId;
}
